export default __webpack_public_path__ + "static/media/MainImage.c25bbc54.png";